import { defaultSysCodeDto, SysCodeDto } from "src/dtos/code/sysCodeDto";
import { defaultUserAutDto, UserAutDto } from "src/dtos/userAut/userAutDto";

export interface SYS3020_R01HeaderDto extends SysCodeDto {
	
}

export const defaultSYS3020_R01HeaderDto: SYS3020_R01HeaderDto = {
	...defaultSysCodeDto,
	minorCd: `$`,
};

/**
 * SYS3020_R01 - 사용자별 메뉴 권한 관리 DTO
 */
export interface SYS3020_R01Dto extends UserAutDto {
    systemCd: string;
    userNm: string;
    menuNm: string;
    useYn: string;
	listLength?: number;
	refetchListLength?: number;
}

export const defaultSYS3020_R01Dto: SYS3020_R01Dto = {
	...defaultUserAutDto,
    systemCd: '',
    userNm: '',
    menuNm: '',
    useYn: '',
	listLength: 0,
	refetchListLength: 0,
};
